import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculatePercent'
})
export class CalculatePercentPipe implements PipeTransform {

  transform(value: number, total: number): string {
    if (value > 0 && total > 0) {
      return (100 * value / total).toFixed(0) + '%';
    }
    else {
      if (total > 0) {
        return '0%';
      }
      else {
        return '';
      }
    }
  }

}
